import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    OpenApiCloudPaymentsRegisterMethod,
    type OpenApiCloudPaymentsRegisterRequest,
    type OpenApiCloudPaymentsRegisterResponseSuccess,
    OpenApiCloudPaymentsRegisterUrl,
    OpenApiGetCloudPaymentsCashierMethod,
    type OpenApiGetCloudPaymentsCashierRequest,
    type OpenApiGetCloudPaymentsCashierResponseSuccess,
    OpenApiGetCloudPaymentsCashierUrl,
    OpenApiSetCloudPaymentsCashierMethod,
    type OpenApiSetCloudPaymentsCashierRequest,
    OpenApiSetCloudPaymentsCashierUrl,
} from '#shared/api/schema';

const cloudPaymentsCashier = 'cloudPaymentsCashier' as const;

const cloudPaymentsApi = createApi({
    name: 'entities/integration/api/cloudPaymentsApi',
    baseQuery: createBaseQuery(apiV1Request),
    tagTypes: [cloudPaymentsCashier],
    endpoints: (builder) => {
        return {
            sendCloudPaymentsRequest: builder.mutation<
                OpenApiCloudPaymentsRegisterResponseSuccess,
                OpenApiCloudPaymentsRegisterRequest
            >({
                query: (payload) => {
                    return {
                        url: OpenApiCloudPaymentsRegisterUrl,
                        method: OpenApiCloudPaymentsRegisterMethod,
                        body: payload,
                    };
                },
            }),
            getCloudKassir: builder.query<
                OpenApiGetCloudPaymentsCashierResponseSuccess,
                OpenApiGetCloudPaymentsCashierRequest
            >({
                query: () => {
                    return {
                        url: OpenApiGetCloudPaymentsCashierUrl,
                        method: OpenApiGetCloudPaymentsCashierMethod,
                    };
                },
                providesTags: [cloudPaymentsCashier],
            }),
            setCloudKassir: builder.mutation<void, OpenApiSetCloudPaymentsCashierRequest>({
                query: (payload) => {
                    return {
                        url: OpenApiSetCloudPaymentsCashierUrl,
                        method: OpenApiSetCloudPaymentsCashierMethod,
                        body: payload,
                    };
                },
                invalidatesTags: (_, error) => {
                    if (error) {
                        return [];
                    }

                    return [cloudPaymentsCashier];
                },
            }),
        };
    },
});

export const useIntegrationGetCloudKassir = cloudPaymentsApi.useGetCloudKassirQuery;
export const setIntegrationCloudKassir = cloudPaymentsApi.endpoints.setCloudKassir.mutate;
